<template>
  <div class="housing-locality-apartments print-break-inside-avoid">
    <LoadSpinner v-if="loading"/>

    <template v-else-if="groups.length > 0">
      <div
        v-html="instructions"
        class="housing-locality-apartments__instructions wysiwyg"
      >
      </div>

      <div class="drawer">

        <div class="drawer__header">
          <span class="drawer__title">
            {{translate('Huoneistotyypit')}}
          </span>
        </div>

        <table class="housing-locality-apartments__table">
          <template v-for="group in groups">
            <tr
              :key="group.id"
              class="housing-locality-apartments__row-header"
              tabindex="0"
              @click="group.open = !group.open"
            >
              <td class="housing-locality-apartments__column-first">
                <div class="housing-locality-apartments__open-icon--wrapper">
                <ChevronIcon
                  class="housing-locality-apartments__open-icon"
                  :class="{'housing-locality-apartments__open-icon--close': group.open}" />
                </div>
              </td>
              <td class="housing-locality-apartments__column-title">
                {{translate(group.title)}}
              </td>
              <td
                colspan="2"
                class="housing-locality-apartments__column-value"
              >
                {{group.areaString}}
              </td>
              <td class="housing-locality-apartments__column-value housing-locality-apartments__column-value--last">
                {{sprintf(translate('%s kpl'), group.apartments.length)}}
              </td>
              <td
                class="housing-locality-apartments__column-favourite print-hide"
                :class="[isButtonDisabled ? 'btn--visually-disabled' : '']"
              >
                <div class="column-favourite-toggle__wrapper">
                  <a
                    v-if="isFavouriteAll(group.apartments)"
                    :href="ctaLink"
                    class="cta-link"
                  >
                    <span class="housing-locality-apartments__favourite-toggle-text">{{translate('Siirry hakemukseen')}}</span>
                  </a>
                <button
                  :class="classFavouriteToggle(isFavouriteAll(group.apartments))"
                  @click.stop="onToggleGroup(group)"
                  v-if="color != 'blue'"
                >
                <MobileMenuXIcon class="remove" v-if="isFavouriteAll(group.apartments)"/>
                  <template v-else>
                    <span
                      class="housing-locality-apartments__favourite-toggle-text">
                      {{translate('Lisää kaikki hakemukseen')}}
                    </span>
                    <span class="housing-locality-apartments__favourite-toggle-text--mobile"><PlusIcon /></span>
                  </template>
                </button>
                </div>
              </td>
            </tr>

            <template v-if="group.open">
              <tr
                v-for="apartment in group.apartments"
                :key="apartment.id"
                class="housing-locality-apartments__row"
              >
                <td
                  class="housing-locality-apartments__column-first housing-locality-apartments__column-value"
                >
                  {{apartment.mpc_huoneistonnimi}}
                </td>
                <td
                  :colspan="apartment.available ? 1 : 2"
                  class="housing-locality-apartments__column-title"
                >
                  <component v-bind="apartmentTitleProps(apartment)">
                    {{apartment.mpc_huoneistotyyppi}}
                  </component>
                  <a
                    v-if="!apartment.available && apartment.imageFloorPlan"
                    :href="apartment.imageFloorPlan.storage_thumbnail"
                    target="_blank"
                    class="housing-locality-apartments__floor-plan-link"
                    :class="`housing-locality-apartments__floor-plan-link--${color}`"
                  >
                    {{translate('Näytä pohjakuva')}}
                  </a>
                </td>
                <td
                  v-if="apartment.available"
                  class="housing-locality-apartments__column-badge"
                >
                  <div class="flex">
                    <div :class="`housing-locality-apartments__badge btn btn--round btn--${color}`">
                      <span v-if="apartment.mpc_status === 'Varattu'">
                        {{translate('Varattu')}}
                      </span>
                      <span v-else>
                      {{apartmentDisplayAvailable(apartment, true)}}
                    </span>
                  </div>
                    <div
                      v-if="apartment.available"
                      class="housing-locality-apartments__column-value column-price"
                    >
                      {{translate(apartmentDisplayPriceTitle(apartment))}}
                      {{apartmentDisplayPrice(apartment)}}
                    </div>
                  </div>
                </td>
                <td class="housing-locality-apartments__column-value">
                  {{formatStringArea(apartment.mpc_pinta_ala)}}
                </td>
                <td class="housing-locality-apartments__column-value housing-locality-apartments__column-value--last">
                  {{apartment.mpc_kerros !== null ? `${apartment.mpc_kerros} ${translate('krs')}` : ''}}
                </td>
                <td
                  class="housing-locality-apartments__column-favourite print-hide"
                  :class="[isButtonDisabled ? 'btn--visually-disabled' : '']"
                  v-if="apartment.type !== 'owner-occupancy'"
                >
                  <div class="column-favourite-toggle__wrapper">
                  <a
                    v-if="isFavourite(apartment)"
                    :href="ctaLink"
                    class="cta-link"
                  >
                    <span class="housing-locality-apartments__favourite-toggle-text">{{translate('Siirry hakemukseen')}}</span>
                  </a>
                  <button
                    :class="[classFavouriteToggle(isFavourite(apartment)), isFavourite(apartment) ? 'favourite--toggled' : '']"
                    @click="toggleFavourite(apartment)"
                  >
                    <MobileMenuXIcon class="remove" v-if="isFavourite(apartment)"/>
                    <template v-else>
                    <span
                      class="housing-locality-apartments__favourite-toggle-text print-hide">
                      {{translate('Lisää hakemukseen')}}
                    </span>
                    <span class="housing-locality-apartments__favourite-toggle-text--mobile"><PlusIcon /></span>
                    </template>
                  </button>

                  </div>
                </td>
                <td
                    class="housing-locality-apartments__column-favourite print-hide"
                    :class="[isButtonDisabled ? 'btn--visually-disabled' : '']"
                    v-if="apartment.type == 'owner-occupancy'"
                  >
                    <div class="column-favourite-toggle__wrapper">
                    <a
                      v-if="isFavourite(apartment)"
                      :href="ctaLink"
                      class="cta-link"
                    >
                      <span class="housing-locality-apartments__favourite-toggle-text">{{ translate('Siirry varaukseen') }}</span>
                    </a>
                    <button
                      :class="[classFavouriteToggle(isFavourite(apartment)), isFavourite(apartment) ? 'favourite--toggled' : '']"
                      @click="toggleFavourite(apartment)"
                    >
                      <MobileMenuXIcon class="remove" v-if="isFavourite(apartment)"/>
                      <template v-else>
                      <span
                        class="housing-locality-apartments__favourite-toggle-text">
                        {{ apartment.mpc_status === 'Varattu' ? translate('Liity jonoon') : translate('Varaa asunto') }}
                      </span>
                      <span class="housing-locality-apartments__favourite-toggle-text--mobile"><PlusIcon /></span>
                      </template>
                    </button>

                    </div>
                  </td>
              </tr>
            </template>
          </template>
        </table>
      </div>
    </template>
    <InfoModal
      v-if="showInfoModal"
    >
      <div v-html="modalContent"></div>

      <template v-slot:actions="slot">
        <button
          class="btn btn--large"
          :class="[`btn--${color}`, slot.classAction]"
          @click="showInfoModal = false"
        >
          {{translate('Sulje')}}
        </button>
      </template>
    </InfoModal>
  </div>
</template>

<script>
  import axios from 'axios';
  import {sprintf} from 'sprintf-js';

  import globals from '../lib/globals';
  import {formatStringArea} from '../lib/format';
  import utils from './mixins/utils';
  import apartmentDisplayFields from './mixins/apartmentDisplayFields';
  import LoadSpinner from './components/LoadSpinner';
  import ApartmentAddedIcon from './icons/ApartmentAddedIcon.vue';
  import ApartmentAddIcon from './icons/ApartmentAddIcon.vue';
  import PlusIcon from './icons/PlusIcon.vue';
  import MobileMenuXIcon from './icons/MobileMenuXIcon.vue';
  import ArrowIcon from './icons/ArrowIcon.vue';
  import ChevronIcon from './icons/ChevronIcon.vue';
  import InfoModal from './components/InfoModal';

  const groupTitles = {
    1: 'Yksiöt',
    2: 'Kaksiot',
    3: 'Kolmiot',
    4: 'Neliöt',
    5: '5+ huonetta',
  };

  export default {
    components: { LoadSpinner, ApartmentAddedIcon, ApartmentAddIcon, PlusIcon, MobileMenuXIcon, ArrowIcon, ChevronIcon, InfoModal },
    mixins: [
      apartmentDisplayFields,
      utils.translate,
      utils.apartmentUrl,
    ],
    props: {
      //TODO check if is this prop really used?
      instructions: {
        type: String,
        required: false,
        default: '',
      },
      housingLocality: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        default: 'default',
      },
      type: {
          type: String,
          required: true,
      },
    },
    data() {
      return {
        loading: false,
        groups: [],
        showInfoModal: false,
      };
    },
    computed: {
        ctaLink() {
          const ctaLink = {
                "right-of-occupancy": globals.urlApplicationRightOfOccupancy,
                "rental": globals.urlApplicationRent,
                "owner-occupancy": globals.urlApplicationOwnerOccupied,
            }[this.type];
            return ctaLink;
        },
        isButtonDisabled() {
          return !globals.userLoggedIn && globals.formDisabledFromWordPress;
        },
        modalContent() {
          return globals.formDisabledFromWordPressReason;
        },
    },
    methods: {
      formatStringArea,
      sprintf,
      apartmentTitleProps(apartment) {
        return apartment.available ? {
          is: 'a',
          href: this.apartmentUrl(apartment),
          class: [
            'housing-locality-apartments__apartment-link',
            `housing-locality-apartments__apartment-link--${this.color}`,
          ],
        } : {is: 'span'};
      },
      onToggleGroup(group) {
        group.open = true;
        this.toggleFavouriteAll(group.apartments);
      },
      isFavourite(apartment) {
        return this.$store.getters.isFavourite(apartment.mpc_asuntoid);
      },
      isFavouriteAll(apartments) {
        return apartments.every(this.isFavourite);
      },
      toggleFavourite(apartment) {
        if (!globals.userLoggedIn && globals.formDisabledFromWordPress) {
          this.showInfoModal = true;
          return false;
        }
        const uuid = apartment.mpc_asuntoid;
        const {type} = apartment;
        const action = this.isFavourite(apartment) ? 'removeFavourite' : 'addFavourite';
        this.$store.commit("emptyFavourites", { type: 'owner-occupancy' });
        this.$store.commit(action, {uuid, type});
        if(apartment.type === 'owner-occupancy' && action === 'addFavourite') {
          window.location.href = this.ctaLink;
        } else {
          if (action === 'addFavourite') this.$store.commit("toggleFavouritesMenuExternal", true);
        }

        //if(action === 'addFavourite') this.$store.commit("toggleFavouritesMenuExternal", true);
      },
      toggleFavouriteAll(apartments) {
        if (!globals.userLoggedIn && globals.formDisabledFromWordPress) {
          this.showInfoModal = true;
          return false;
        }
        const action = this.isFavouriteAll(apartments) ? 'removeFavourite' : 'addFavourite';
        apartments.forEach(apartment => {
          if (apartment.type != 'owner-occupancy') { // Don't add to favourites if owner occupancy apartment
            const uuid = apartment.mpc_asuntoid;
            const {type} = apartment;
            this.$store.commit(action, {uuid, type});
          }
        });
        if(action === 'addFavourite') this.$store.commit("toggleFavouritesMenuExternal", true);
      },
      classFavouriteToggle(active) {
        return [
          'housing-locality-apartments__favourite-toggle',
          `housing-locality-apartments__favourite-toggle--${this.color}`,
          {'housing-locality-apartments__favourite-toggle--active': active},
        ];
      }
    },
    async beforeMount() {
      this.loading = true;
      const url = `${globals.urlIntegrationApi}/public/apartments-by-housing-locality/${this.housingLocality}`;
      const response = await axios.get(url);
      const apartments = response.data;

      const apartmentsGrouped = {};
      apartments.forEach(apartment => {
        const id = Math.min(apartment.room_count, 5);
        if (!apartmentsGrouped.hasOwnProperty(id)) {
          apartmentsGrouped[id] = [];
        }
        apartmentsGrouped[id].push(apartment);
      });

      this.groups = Object
        .entries(apartmentsGrouped)
        .sort((a, b) => a[0] === b[0] ? 0 : (a[0] < b[0] ? -1 : 1))
        .map(([id, apartments]) => {
          const areas = apartments.map(apartment => parseFloat(apartment.mpc_pinta_ala));
          const areaMin = areas.reduce((accumulator, area) => Math.min(accumulator, area));
          const areaMax = areas.reduce((accumulator, area) => Math.max(accumulator, area));
          const areaString = areaMin === areaMax
            ? formatStringArea(areaMin)
            : `${formatStringArea(areaMin, false)} - ${formatStringArea(areaMax)}`;

          return {
            id,
            apartments: apartments.sort((a, b) => {
              const aArea = a.mpc_pinta_ala;
              const bArea = b.mpc_pinta_ala;
              return aArea - bArea || a.mpc_huoneistonnimi.localeCompare(b.mpc_huoneistonnimi);
            }),
            title: groupTitles[id],
            areaString,
            open: false,
          };
        });

      this.loading = false;
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  @mixin housing-locality-apartments__row {

  }

  @mixin housing-locality-apartments__column {
    white-space: nowrap;
    padding: 0;
  }

  @mixin housing-locality-apartments__favourite-toggle-inverted {
    &:hover,
    &:focus {
      @content;
    }
  }

  @mixin housing-locality-apartments__favourite-toggle-inverted-child {
    .housing-locality-apartments__favourite-toggle:hover &,
    .housing-locality-apartments__favourite-toggle:focus & {
      @content;
    }
  }

  .housing-locality-apartments {
    @include reverse-container(xs);
    // I don't like having these here but the options are a bit limited
    margin-top: r(48);
    margin-bottom: r(48);
  }

  .housing-locality-apartments__instructions {
    @include font-responsive-body-large;
    margin-bottom: r(32);
  }

  .housing-locality-apartments__table {
    width: 100%;
    border-spacing: 0;
    /*
    border: 1px red solid;
    td {
    border: 1px red solid;
    }
    */
  }

  .housing-locality-apartments__row {
    @include housing-locality-apartments__row;
  }

  .housing-locality-apartments__row-header {
    @include housing-locality-apartments__row;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }

  .housing-locality-apartments__column-first {
    @include housing-locality-apartments__column;
    height: r(44);

    &.housing-locality-apartments__column-value {
      padding-right: r(4);

      @include media-breakpoint-up(sm) {
        padding-bottom: r(3);
      }
    }

  }

  .housing-locality-apartments__open-icon {
    transition: transform 0.2s;
    transform: rotate(0deg);

    &--close {
      transform: rotate(180deg);
    }

    &--wrapper {
      display: flex;
      align-items: center;
      width: r(28);
    }
  }

  .housing-locality-apartments__column-title {
    @include housing-locality-apartments__column;
    @include font-label-11;
    padding: 0 r(10);
    width: 100%;

    @include media-breakpoint-up(sm) {
      @include font-h-uc-12;
      padding-right: r(20);
      padding-left: r(6);
    }
  }

  .housing-locality-apartments__apartment-link {
    color: $color-green-2025;
    text-decoration: underline;
  }

  .housing-locality-apartments__floor-plan-link {
    @include font-label-11;
    color: $color-green-2025;
    text-decoration: underline;
  }

  .housing-locality-apartments__column-badge {
    @include housing-locality-apartments__column;
    padding-top: r(8);
    padding-bottom: r(8);
    padding-right: r(8);
    text-align: right;

    @include media-breakpoint-up(sm) {
      //padding-right: r(24);
    }

    .flex {
      display: flex;
      flex-direction: column;
      @include media-breakpoint-up(md) {
        flex-direction: row;
        align-items: center;
      }
    }
  }

  .housing-locality-apartments__badge.btn {
    @include font-label-12;
    font-size: r(10);
    min-height: r(24);
    padding: r(4) r(8);
    text-transform: uppercase;
    letter-spacing: r(0.3);
    cursor: default;

    @include media-breakpoint-up(sm) {
      padding: r(4) r(12);
      font-size: r(12);
    }
  }

  .housing-locality-apartments__column-value {
    @include housing-locality-apartments__column;
    @include font-body-12;
    padding-right: r(8);
    text-align: right;

    @include media-breakpoint-up(sm) {
      padding-right: r(12);
    }

    &--last {
      @include media-breakpoint-up(xl) {
        padding-right: r(20);
      }
    }

    &.column-price {
      padding: r(8) 0 0 0;
      text-align: center;
      @include media-breakpoint-up(md) {
        padding: 0 0 0 r(8);
      }
    }
  }

  .column-favourite-toggle__wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;

    @include media-breakpoint-up(md) {
      width: r(128);
    }
  }

  .housing-locality-apartments__column-favourite {
    @include housing-locality-apartments__column;

    @include media-breakpoint-up(md) {
      padding-right: r(0);
    }

    &.btn--visually-disabled {
      opacity: 0.4;
    }
  }

  .housing-locality-apartments__favourite-toggle {
    @include reset-button(true);
    display: flex;
    align-items: center;
    justify-content: center;
    height: r(30);
    color: $color-green-2025;
    background-color: none;
    white-space: normal;
    text-align: left;
    text-decoration: underline;
    word-break: auto-phrase;

    @include media-breakpoint-up(md) {
      width: 100%;
      // padding-right: r(8);
    }

    &.favourite--toggled {
      width: r(32);
    }

    .icon {
      margin-right: $theme-spacing * 0.5;

      > svg {
        stroke: $black;
      }
    }

    .icon.remove {
      width: r(30);
      > svg {
        width: r(30);
        height: r(30);
      }
      >svg g {
        transform: scale(1.5) rotate(45deg);
        transform-origin: -16% 43%;
        stroke: $black;
      }
    }
  }

  .housing-locality-apartments__favourite-toggle-icon {
    width: r(40);
    display: flex;
    justify-content: center;
    color: $color-black;

    @include housing-locality-apartments__favourite-toggle-inverted-child {
      color: $color-white;
    }

    .housing-locality-apartments__favourite-toggle--active & {
      color: currentColor;
    }
  }

  .housing-locality-apartments__favourite-toggle-text {
    @include font-label-14;
    display: none;
    color: $color-black;

    @include media-breakpoint-up(sm) {
      display: block;
    }

    @include housing-locality-apartments__favourite-toggle-inverted-child {
      //color: $color-white;
    }

    .housing-locality-apartments__favourite-toggle--active & {
     // color: currentColor;
    }
    &--mobile {
      display: block;
      @include media-breakpoint-up(sm) {
        display: none;
      }
    }
  }

  .cta-link {
    color: $color-yellow;

    &--icon {
      transform: scale(0.7);
    }
  }
</style>
